<template>
  <div class="activity0728" id="activity0728">
    <AppHeader/>
    <div class="act-ctn">
      <div class="bg-box">
      	<div class="bg-item bg1"></div>
      	<div class="bg-item bg2"></div>
      	<div class="bg-item bg3"></div>
      </div>
      <div class="content-box">
      	<div class="banner-ctn">
      		<div class="priceAndName-box">
      			<a class="r-btn" @click="goParkate">立即购买</a>
      		</div>
      	</div>
      	<div class="main">
      	  <div v-for="(row,rowindex) in pageData" class="row" :class="'row'+(rowindex+1)">
      	    <div class="ctn-box">
      	      <div class="title-box">
      	        <h3>{{row.title}}</h3>
      	        <p v-html="row.titleBtm"></p>
      	      </div>
      	      <div class="clearfix character-list" v-if="row.characterList" :class="'f'+row.characterList.length">
      	        <span class="ct-item" v-for="pitem in row.characterList">
      	          <p v-for="text in pitem">{{text}}</p>
      	        </span>
      	      </div>
      	      <div class="block">
      	        <el-carousel trigger="click" height="682px">
      	          <el-carousel-item v-for="(item,index) in row.carouselData" :key="index">
      	            <img :src="require('../../assets/images/product/338/carousel/c0'+item)"/>
      	          </el-carousel-item>
      	        </el-carousel>
      	      </div>
      	    </div>
      	  </div>
      	</div>
      	<div class="btmfix-tip">
      		股市有风险 入市需谨慎
      	</div>
      </div>
      
    </div>
  	
  </div>
</template>


<script>
import AppHeader from "@/components/common/AppHeader.vue";
export default {
	name: 'activity0728',
  components: {
    AppHeader,
  },
  data () {
    return {
        pageData:[
          {
            title:'极速行情，全景看盘',
            titleBtm:'专业的看盘界面，<br/>只为更快更好的及至看盘体验',
            carouselData:['1/img1.png','1/img2.png','1/img3.png']
          },{
            title:'智能选股',
            titleBtm:'基本面、技术面、资金面、消息面；一句话、一个关键词即可全局搜索',
            carouselData:['3/img1.png','3/img2.png','3/img1.png','3/img2.png']
          }, {
            title:'新闻资讯数据全覆盖',
            titleBtm:'汇聚宏观行业政策、机构观点、主力资金动向、个股分析等高投资价值资讯数据。',
            characterList:[
              ['宏观、行业资讯、','个股F10、北向资金'],
              ['7*24小时不间断，','及时、专业的财经数据资讯'],
              ['个股公告研报秒更新']
            ],
            carouselData:['4/img1.png','4/img2.png','4/img3.png']
          },
        ]
    }
  },
  created () {
    document.title = '大智慧启航版';
  },
  methods: {
    goParkate () {
      this.$router.push("/order/confirm/338/12");
    }
  },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
* {
    margin: 0;
    padding: 0;
}
a{
	text-decoration: none;
}
ul,li{
	list-style: none;
}
$url:'../../assets/images/activity/activity0728/';
.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: " ";
  clear: both;
  height: 0;
}
$color:#7c35ff;
body{

}

/deep/.activity0728{
  .act-ctn{
    width:1300px;
    margin: 0 auto;
    position:relative;
    background-color: #857ae1;
    z-index: 1;
  }
  
  .bg-box{
  	position: absolute;
  	top: 0;
  	left: 0;
  	z-index: 0;
  	width: 100%;
  	height: 100%;
  	.bg-item{
  		&.bg1{
  			height: 829px;
  			background: url($url+'bg1.jpg')no-repeat center top/100%;
  		}
  		&.bg2{
  			height: 1175px;
  			background: url($url+'bg2.jpg')no-repeat center top/100%;
  		}
  		&.bg3{
  			height: 1685px;
  			background: url($url+'bg3.jpg')no-repeat center top/100%;
  		}
  	}
  }
  .content-box{
  	position: relative;
  	z-index: 1;
  	padding: 0 22px;
  	box-sizing: border-box;
  	.banner-ctn{
  		padding-top: 606px;
  		height: 2004px;
  		box-sizing: border-box;
  		.top-ctn-tip{

  		}
  		.priceAndName-box{
          width: 78%;
          width: 1014px;
          padding: 52px 0 0 692px;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
          margin: 0 auto;
  			.l-box{
  				p{}
  				.m-p{
  					span{}
  					.old-p{}
  				}
  				.price-num-box{
  					.dz{}
  					.price-num{
  						span{}
  					}
  				}
  			}
  			.r-btn{
            width: 288px;
            height: 99px;
            border-radius: 0.68rem;
            border: 1px solid #000;
            display: block;
            font-size: 0.24rem;
            opacity: 0;
  			}
  		}
  	}
  	.white-box{
  		width:100%;
  		height: 12.18rem;
  		background:#fff;
  		border-radius: 0.08rem;
  		padding-top: 0.92rem;
  		.w-item{
  			.top-tle{
  				.bred{}
  			}
  			.lf-box{
  				.lf-tle{}
  				.lf-tip{}
  				.img-box{
  					img{}
  				}
  			}
  			.tr-box{

  			}
  		}
  	}
  	.main {
  	  margin: 0 auto;
  	  padding: 0;
  	  .row {
  	    h3 {

  	    }
  	    .ctn-box{
  	      width: 1200px;
  	      margin: 0 auto;
  	      padding-bottom: 106px;
          padding-bottom: 0px;
  	      .title-box{
  	        text-align: center;
  	        padding-top: 71px;
  	        h3{
  	          color: #fff;
  	          font-size: 40px;
  	          height: 58px;
  	          line-height: 40px;
  	          text-align: center;
  	          box-sizing: border-box;
  	          padding-top: 18px;
  	          //background: url($url+'titlebg.png')no-repeat center/636px;
  	        }
  	        p{
  	          padding-top: 16px;
  	          font-size: 20px;
  	          color: #fff;
  	        }
  	      }
  	      .character-list{
  	        margin-top: 42px;
  	        margin-bottom: 44px;
  	        display: flex;
  	        .ct-item{
  	          width: 372px;
  	          height: 253px;
  	          border-radius: 10px;
  	          background-color: #fff;
  	          box-shadow: 0px 15px 40px rgba(0,0,0,0.2);
  	          padding-top: 27px;
  	          position: relative;
  	          box-sizing: border-box;
  	          display: inline-block;
  	          float: left;
  	          &:last-child{
  	            margin-right: 0;
  	          }

  	          margin-right: 42px;

  	          &:before{
  	            content: '';
  	            width: 120px;
  	            height: 120px;
  	            border-radius: 120px;
  	            display: block;
  	            margin: 0 auto 16px;
  	          }
  	          p{
  	            font-size: 20px;
  	            color: #30303f;
  	            text-align: center;
  	            line-height: 30px;
  	          }
  	        }
  	        &.f4{
  	          .ct-item{
  	            width: 278px;
  	            margin-right: 30px;
  	            &:last-child{
  	              margin-right: 0;
  	            }
  	          }
  	        }

  	      }
  	      .block{
  	        margin-top: 40px;
  	        .el-carousel{
  	          width: 1200px;
  	          height: 682px;
              // width: 1014px;
              // height: 576px;
              margin: 0 auto;
              overflow: hidden;
  	          border-radius: 6px;
  	          border: 4px solid #fff;
  	          box-shadow: 0px 15px 40px rgba(0,0,0,0.2);
              .el-carousel__container{
                .el-carousel__arrow{

                  width: 85px;
                  height: 85px;
                  border-radius: 85px;
                  background: transparentize(#555c6f, .7);
                  i{
                    font-size: 40px;
                  }
                  &:hover{
                    background: transparentize(#555c6f, .6);
                  }
                }
              }
  	          .el-carousel__item{
  	            img{
  	              width: 100%;
  	              height: 100%;
  	            }
  	          }

  	          .el-carousel__indicators{
  	            display: none;
  	          }
  	        }
  	      }
  	    }
  	    &.row2,&.row4{
  	      //background: url($url+'bg2.jpg')no-repeat center/1920px;
  	      .ctn-box{
  	        //padding-bottom: 95px;
  	      }
  	    }
  	    .character-list{
          &.f3{
            .ct-item{
              &:before{
                content: '';
                display: block;
                //background-image: url($url+'icons1.png');
                background-image: url($url+'icons2.png');
                background-size: 944px;
                background-repeat: no-repeat;
              }
              &:nth-child(2){
                &:before{
                  background-position: -416px -4px;
                }
              }
              &:nth-child(3){
                &:before{
                  background-position: -824px 0px;
                }
              }
            }
          }

  	    }
  	    &.row4{
  	      .character-list{
  	        .ct-item{
  	          &:before{
  	            content: '';
  	            display: block;
  	            background-image: url($url+'icons2.png');
  	            background-size: 944px;
  	            background-repeat: no-repeat;
  	          }
  	          &:nth-child(2){
  	            &:before{
  	              background-position: -416px -4px;
  	            }
  	          }
  	          &:nth-child(3){
  	            &:before{
  	              background-position: -824px 0px;
  	            }
  	          }
  	        }
  	      }
  	    }
  	  }
  	}
  	.btmfix-tip{
  		font-size: 18px;
  		color: #fff;
  		padding-bottom: 20px;
      padding-top: 60px;
  		box-sizing: border-box;
  	}
  }

}

</style>



// WEBPACK FOOTER //
// src/pages/activity/activity0728.vue